import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import { dateTimeFormatter, getActionLogData, localeFormatter } from '../../../utils/formatters';
import { getReferenceInformationData } from '../../ReferenceInformation/reducer';
import { getRegisterData } from '../reducer';
import { APPLICATION_SUBJECT_TYPES, SUBJECT_TYPE } from '../../../configs';
import Switches from '../../../components/fields/Switches/Switches';

export default function RegistryHistoryDialog({ current = null, close = () => {} }) {
  const {
    currentUserActivity = {},
  } = useSelector(getReferenceInformationData);
  const { formatMessage } = useIntl();
  const [showData, setShowData] = useState(false);
  const [switchValue, setSwitchValue] = useState(false);
  const columns = [
    {
      dataField: 'name',
      text: 'Имя поля',
      headerClassName: 'field-name-column',
      disableSort: true,
    },
    {
      dataField: 'prev',
      text: 'Данные до изменений',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'new',
      text: 'Данные после изменений',
      headerClassName: 'module-column',
      disableSort: true,
    },
    {
      dataField: 'current',
      text: 'Текущее значение',
      headerClassName: 'module-column',
      disableSort: true,
    },
  ];

  const { subject_type, subject_id } = currentUserActivity;
  const list = getActionLogData(currentUserActivity);
  const gridData = switchValue ? list?.filter(e => e.prev !== e.new) || [] : list || [];

  return (
    <Dialog
      className="registry-history-dialog"
      onClose={close}
      open
    >
      <DialogTitle header="История изменений" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="registry-history-dialog-content">
        <div className="registry-history-dialog-content-title">
          <div className="f4 mt-4">Внесенные изменения</div>
          <Switches
            withLabel
            label="Только изменения"
            inputProps={{
              value: switchValue,
              onChange: () => {
                setSwitchValue(!switchValue);
              },
            }}
            placeholder="Select input placeholder"
            variant="material"
            inverse
          />
        </div>
        <div className="registry-history-table">
          <Grid
            data={gridData}
            columns={columns}
            name="application-list"
          />
        </div>
      </DialogContent>
      <DialogFooter>
        <div className="registry-history-view">
          <div className="registry-view-header" onClick={() => setShowData(!showData)}>
            <div className="registry-view-header-name">Карточка объекта</div>
            <div className={classNames('registry-view-header-button', { show: showData })}>
              {APPLICATION_SUBJECT_TYPES.includes(subject_type) ? (
                <NavLink
                  to={`/application?application_id=${subject_id}`}
                >{localeFormatter('subject.type', subject_type)}
                </NavLink>
              ) : null}
              {subject_type === SUBJECT_TYPE.CARRIER ? (
                <NavLink
                  to={`/region-registry-carrier?registry_id=${subject_id}`}
                >{localeFormatter('subject.type', subject_type)}
                </NavLink>
              ) : null}
              {subject_type === SUBJECT_TYPE.ORDER_SERVICE ? (
                <NavLink
                  to={`/region-registry/szlt?registry_id=${subject_id}`}
                >{localeFormatter('subject.type', subject_type)}
                </NavLink>
              ) : null}
              {subject_type === SUBJECT_TYPE.VEHICLE ? (
                <NavLink
                  to={`/region-registry/passenger-taxi?registry_id=${subject_id}`}
                >{localeFormatter('subject.type', subject_type)}
                </NavLink>
              ) : null}
            </div>
          </div>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
